/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'icon-comment-success': {
    width: 28,
    height: 28,
    viewBox: '0 0 28 28',
    data: '<path pid="0" d="M14 0C6.3 0 0 6.3 0 14s6.3 14 14 14 14-6.3 14-14S21.7 0 14 0zm7.98 10.64l-9.94 9.94s-.14.14-.28.14-.14.14-.28.14h-1.12c-.14 0-.14-.14-.28-.14s-.14-.14-.28-.14l-3.92-3.92c-.56-.56-.56-1.4 0-1.96s1.4-.56 1.96 0l2.94 2.94 8.96-8.96c.56-.56 1.4-.56 1.96 0 .84.56.7 1.4.28 1.96z" _fill="#29CE42"/>'
  }
})
